import { useSettings } from "@/context/SettingsContext";
import { money } from "@/lib/api";
import { Truck, PartyPopper } from "lucide-react";

export default function FreeShippingBar({ subtotal }) {
  const s = useSettings();
  const threshold = Number(s?.free_shipping_threshold ?? 1000);
  const pct = Math.min(100, (subtotal / threshold) * 100);
  const remaining = Math.max(0, threshold - subtotal);
  const qualifies = subtotal >= threshold;

  return (
    <div data-testid="free-shipping-progress" className="rounded-xl border bg-white p-4">
      <div className="flex items-center gap-2 text-sm font-medium">
        {qualifies ? (
          <><PartyPopper size={16} className="text-emerald-600" />
            <span data-testid="free-shipping-message" className="text-emerald-700">
              Congratulations! Your order qualifies for FREE NZ shipping.
            </span></>
        ) : (
          <><Truck size={16} className="text-accent" />
            <span data-testid="free-shipping-message" className="text-steel">
              Add another <strong>{money(remaining)}</strong> to your order to receive FREE NZ shipping.
            </span></>
        )}
      </div>
      <div className="mt-3 h-3 rounded-full bg-slate-100 border overflow-hidden">
        <div
          className="h-full bg-gradient-to-r from-accent to-amber-600 transition-all duration-500 ease-out"
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
}
